package one.healthium.insights.ui.components

import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
fun rememberAnchorState() = remember { AnchorState() }

class AnchorState {

    private val bringIntoViewRequesters = mutableMapOf<String, BringIntoViewRequester>()

    fun getOrCreateBringIntoViewRequester(id: String): BringIntoViewRequester {
        return bringIntoViewRequesters.getOrPut(id) {
            BringIntoViewRequester()
        }
    }
}